/** Canonical app origin for absolute URLs (emails, impersonation). Falls back to current page origin. */
export const getAppOrigin = () =>
  (process.env.REACT_APP_APP_URL || "").replace(/\/$/, "") ||
  (typeof window !== "undefined" ? window.location.origin.replace(/\/$/, "") : "");
